import { Itemset, ItemsetResult } from "../../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { Task } from "../../../../store/viewmodels/TaskViewModel";
import { getNextUrl, postCheck } from "../../../../utils/TaskNavigationServices";
import React, { useEffect, useState } from "react";
import { GameBoard } from './GameBoard';
import { useHistory } from "react-router-dom";
import './MemoryGameStyles.css';
import { useAppDispatch, useAppSelector } from "../../../../store/Hooks";
import { StudentData } from "../../../../store/viewmodels/StudentViewModel";
import { addAnswerToSet, addItemSet, addStudentId, postAnswerSet, resetAsSliceState, setEndTime, setStartTime } from "../../../../store/AnswerSetSlice";
import { Answer } from "../../../../store/viewmodels/AnswerViewModel";
import MemoryGameModal from "./MemoryGameModal";
import ModalWrapper from "../../../utils/modal/ModalWrapper";
import LoadingModal from "../../../LoadingModal";
import FeedBack from "../FeedBack";
import Header from "../Header";

export interface StudentMemoryGameProps {
    task: Task;
    itemset: Itemset,
    item: Item
}

const EASY: number = 4;
const MEDIUM: number = 6;
const HARD: number = 12;

function StudentMemoryGameItem(props: StudentMemoryGameProps) {
    const history = useHistory();

    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData)
    let aStartTime = new Date()

    const [feedBackType, setFeedBackType] = React.useState("");
    const [content, setContent] = useState(<></>);
    const [isModalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState("loading");


    const showModal = () => {
        if (feedBackType === "") {
            setModalVisible(wasModalVisible => !wasModalVisible);
        }
    }

    const instructionModal = <MemoryGameModal item={props.item} close={showModal} />;
    const goodFeedBackModal = <FeedBack correct={true} itemId={props.item.id} />;
    const badFeedBackModal = <FeedBack correct={false} itemId={props.item.id} />;

    const showInstruction = () => {
        setModalType("memorygame");
        setContent(instructionModal);
        showModal();
    }

    React.useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type };
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime = new Date();
        dispatch(setStartTime(asStartTime.toISOString()));
        setGameEnded(false);
        setPairs(0);
        setScore(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        switch (feedBackType) {
            case "correct": {
                setModalType("feedBack");
                setContent(goodFeedBackModal);
                setModalVisible(true);
                break;
            }
            case "wrong": {
                setModalType("feedBack");
                setContent(badFeedBackModal);
                setModalVisible(true);
                break;
            }
            default: {
                setModalVisible(false);
                break;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [feedBackType]);

    const commitAnswer = () => {
        let answer: Answer = {} as Answer;
        let aEndTime = new Date();
        answer.item = props.item.id;
        answer.value = gameLevel + ";" + score.toString();
        answer.end_time = aEndTime.toISOString()
        answer.start_time = aStartTime.toISOString()
        dispatch(addAnswerToSet(answer));
        const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
        history.push(nextUrl);

        if (postAnswerSetCheck) {
            let asEndTime = new Date()
            dispatch(setEndTime(asEndTime.toISOString()));
            dispatch(postAnswerSet())
                .then(() => {
                    dispatch(resetAsSliceState())
                })
        } else {
            setScore(0);
            setGameLevel(0);
            setPairs(0);
            setGameEnded(false);
        }
    }

    const [score, setScore] = React.useState(0);
    const [gameLevel, setGameLevel] = React.useState(0);
    const [pairs, setPairs] = React.useState(0);
    const [gameEnded, setGameEnded] = React.useState(false);
    const [forward, setForward] = React.useState(false);
    const [turn, setTurn] = React.useState(false);

    let mediumHidden = "";
    let hardHidden = "";

    if (props.item.child_items.length < MEDIUM) {
        mediumHidden = "hidden";
        hardHidden = "hidden";
    } else if (props.item.child_items.length < HARD) {
        hardHidden = "hidden";
    }

    useEffect(() => {
        setModalType("loading");
        setModalVisible(true);
        setContent(<LoadingModal message={"Peli latautuu"} />);

        setTimeout(() => {
            setModalVisible(false);
            setContent(<MemoryGameModal item={props.item} close={showModal} />);
        }, 2000);

        setGameEnded(false);
        setPairs(0);
        setScore(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameLevel]);

    const nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets);
    let parentFiles = props.item.files;

    let isInstruction = false;
    if (parentFiles.length > 0) {
        for (let i: number = 0; i < parentFiles.length; i++) {
            if (parentFiles[i].is_instruction) {
                isInstruction = true;
                break;
            }
        }
    }

    useEffect(() => {
        if (gameEnded && gameLevel > 0) {
            setForward(true);
        }
        else if (!gameEnded && gameLevel > 0) {
            setForward(false);
        }
        else {
            setForward(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pairs, gameEnded]);

    useEffect(() => {
        if (pairs === gameLevel) {
            setGameEnded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pairs]);

    let levelButtons = (
        <div className="mb-2 flex m-auto justify-center text-center content-center">
            <div className="mx-1 4xl:mx-2 6xl:mx-4">
                <button className="h-8 md:h-10 lg:h-12 3xl:h-16 6xl:h-20 w-16 lg:w-24 2xl:w-36 3xl:w-40 6xl:w-48 my-1 border-2 4xl:border-4 border-teal-500 rounded-lg focus:shadow-outline focus:bg-teal-100 hover:bg-teal-200" type="button" onClick={() => {
                    setGameLevel(EASY);
                }} >
                    <span className="text-lg md:text-xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl 6xl:text-6xl text-green-500 ri-game-fill"></span>
                </button>
            </div>
            <div className="mx-1 4xl:mx-2 6xl:mx-4">
                <button className={"h-8 md:h-10 lg:h-12 3xl:h-16 6xl:h-20 w-16 lg:w-24 2xl:w-36 3xl:w-40 6xl:w-48 my-1 border-2 4xl:border-4 border-teal-500 rounded-lg focus:shadow-outline focus:bg-teal-100 hover:bg-teal-200 " + mediumHidden} type="button" onClick={() => {
                    setGameLevel(MEDIUM);
                }}>
                    <span className="text-lg md:text-xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl 6xl:text-6xl text-yellow-500 ri-game-fill"></span>
                    <span className="text-lg md:text-xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl 6xl:text-6xl text-yellow-500 ri-game-fill"></span>
                </button>
            </div>
            <div className="mx-1 4xl:mx-2 6xl:mx-4">
                <button className={"h-8 md:h-10 lg:h-12 3xl:h-16 6xl:h-20 md:w-16 lg:w-24 2xl:w-36 3xl:w-40 6xl:w-48 my-1 border-2 4xl:border-4 border-teal-500 rounded-lg focus:shadow-outline focus:bg-teal-100 hover:bg-teal-200 " + hardHidden} type="button" onClick={() => {
                    setGameLevel(HARD);
                }}>
                    <span className="text-lg md:text-xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl 6xl:text-6xl text-red-500 ri-game-fill"></span>
                    <span className="text-lg md:text-xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl 6xl:text-6xl text-red-500 ri-game-fill"></span>
                    <span className="text-lg md:text-xl lg:text-3xl 2xl:text-4xl 3xl:text-5xl 6xl:text-6xl text-red-500 ri-game-fill"></span>
                </button>
            </div>
        </div>
    );

    let gameButtons = (
        <div className="flex w-full">
            <div className="flex m-auto justify-center ">
                {levelButtons}
            </div>
            <div className="max-w-1/2 flex m-auto justify-center text-lg md:text-xl lg:text-2xl xl:text-3xl 4xl:text-4xl 7xl:text-5xl 10xl:text-6xl text-teal-500 gap-2 md:gap-3 xl:gap-10">
                <div className="text-center">{"Löydettyjä pareja"}</div>
                <div className="">{pairs}</div>
            </div>
        </div>
    );

    let headerRow = <Header type="memoryGame" commitAnswer={commitAnswer} goForward={forward} isInstruction={isInstruction} showInstruction={showInstruction} gameButtons={gameButtons} />
    let gameBoard: JSX.Element = <div></div>;



    if (gameLevel === 0) {
        gameBoard = <div className="m-auto text-center text-lg md:text-xl lg:text-2xl xl:text-3xl 4xl:text-4xl 7xl:text-5xl 10xl:text-6xl text-teal-500">Valitse ensin vaikeustaso</div>;
    }
    else {
        gameBoard = <GameBoard amountOfPairs={gameLevel} item={props.item} setScore={setScore} score={score} setPairs={setPairs} pairs={pairs} turn={turn} setTurn={setTurn} setFeedBackType={setFeedBackType} />;
    }

    return (
        <div className="h-fit w-fit">
            {<ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={modalType} />}
            <div>
                <div className="flex justify-center">
                    {gameBoard}
                </div>
                {headerRow}
            </div>
        </div>
    );
}

export default StudentMemoryGameItem;
